"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastViewport = exports.ToastTitle = exports.ToastProvider = exports.ToastDescription = exports.ToastClose = exports.Toast = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var ToastPrimitive = _interopRequireWildcard(require("@radix-ui/react-toast"));
var _lucideReact = require("lucide-react");
var _cn = _interopRequireDefault(require("@/utils/cn"));
var _excluded = ["className"],
  _excluded2 = ["className", "variant"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"];
/* eslint-disable react/jsx-props-no-spreading, react/no-multi-comp */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ToastProvider = exports.ToastProvider = ToastPrimitive.Provider;
var ToastViewport = exports.ToastViewport = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ToastPrimitive.Viewport, (0, _extends2["default"])({
    ref: ref,
    className: (0, _cn["default"])('fixed left-1/2 top-4 z-toast flex max-h-screen w-[calc(100%-2rem)] max-w-5xl -translate-x-1/2 flex-col gap-2 outline-none', className)
  }, props));
});
ToastViewport.displayName = ToastPrimitive.Viewport.displayName;
var Toast = exports.Toast = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'default' : _ref2$variant,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(ToastPrimitive.Root, (0, _extends2["default"])({
    ref: ref,
    className: (0, _cn["default"])('group pointer-events-auto relative flex w-full items-center gap-4 overflow-hidden rounded-xl border bg-white px-6 py-4 shadow-lg transition-all data-[state=closed]:animate-out data-[state=open]:animate-in data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=open]:slide-in-from-top-full', variant === 'success' && 'border-success-regular shadow-success-regular/30', className)
  }, props));
});
Toast.displayName = ToastPrimitive.Root.displayName;
var ToastTitle = exports.ToastTitle = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(ToastPrimitive.Title, (0, _extends2["default"])({
    ref: ref,
    className: (0, _cn["default"])('text-base font-bold leading-tight text-gray-900', className)
  }, props));
});
ToastTitle.displayName = ToastPrimitive.Title.displayName;
var ToastDescription = exports.ToastDescription = /*#__PURE__*/_react["default"].forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(ToastPrimitive.Description, (0, _extends2["default"])({
    ref: ref,
    className: (0, _cn["default"])('mt-1 text-sm leading-snug text-gray-600', className)
  }, props));
});
ToastDescription.displayName = ToastPrimitive.Description.displayName;
var ToastClose = exports.ToastClose = /*#__PURE__*/_react["default"].forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
    props = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement(ToastPrimitive.Close, (0, _extends2["default"])({
    ref: ref,
    "aria-label": "Close notification",
    className: (0, _cn["default"])('absolute right-2 top-2 rounded-md p-1 text-gray-500 transition-colors hover:text-gray-900 focus:outline-none focus:ring-2', className),
    "toast-close": ""
  }, props), /*#__PURE__*/_react["default"].createElement(_lucideReact.X, {
    className: "h-4 w-4"
  }));
});
ToastClose.displayName = ToastPrimitive.Close.displayName;